export default "__VITE_ASSET__6GI4Ljue__"